/* tslint:disable */
/* eslint-disable */
export enum WorkTaskLinkSyncStatusEnum {
  MissingInitialAgreement = 'MISSING_INITIAL_AGREEMENT',
  Identical = 'IDENTICAL',
  PendingChanges = 'PENDING_CHANGES',
  Conflict = 'CONFLICT'
}
